<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>

  <div class="body" *ngIf="mainViewVisible">
    <mat-tab-group mat-stretch-tabs class="tab-group">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            class="errorIcon"
            *ngIf="
              getErrorsForTitles([
                insideSurveyCablingProposal.OUTSIDE_INTRO_PHOTO_SUBTITLE
              ])
            "
            >warning</mat-icon
          >
          <span i18n="@@survey.inside.cabling.proposal.title.outsideintrophoto">
            Outside intro photo
          </span>
        </ng-template>
        <div
          style="display: flex; align-items: center; gap: 0.5rem"
          class="sub-title required"
        >
          <mat-icon
            *ngIf="
              getErrors(
                insideSurveyCablingProposal.OUTSIDE_INTRO_PHOTO_SUBTITLE
              )
            "
            style="color: red"
          >
            warning
          </mat-icon>
          <div i18n="@@survey.inside.cabling.proposal.title.outsideintrophoto">
            Outside intro photo
          </div>
        </div>
        <div class="section">
          <app-photo-and-remark
            [photos]="viewmodel.outsideIntroPhotos"
            [surveyId]="survey.id"
            [limit]="1"
            [isAuthCanWrite]="isAuthCanWrite"
            [camera]="camera"
            [cameraLayer]="cameraLayer"
            [surveyType]="surveyType.Inside"
            [surveyPhotoType]="surveyPhotoType.OutsideIntro"
            [remarkFieldName]="generalPhotoRemarkFieldName"
            [isInsidePhoto]="true"
            componentDescriptionTitle="Outside Intro"
          ></app-photo-and-remark>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            class="errorIcon"
            *ngIf="
              getErrorsForTitles([
                insideSurveyCablingProposal.FLOOR_PLAN_PHOTO_SUBTITLE,
                insideSurveyCablingProposal.BUILDING_LAYOUT_SUBTITLE
              ])
            "
            >warning</mat-icon
          >
          <span
            i18n="@@survey.inside.cabling.proposal.title.floorplanandbuilding"
            >Floor plan & building layout</span
          ></ng-template
        >
        <div
          style="display: flex; align-items: center; gap: 0.5rem"
          class="sub-title required"
        >
          <mat-icon
            *ngIf="
              getErrors(insideSurveyCablingProposal.FLOOR_PLAN_PHOTO_SUBTITLE)
            "
            style="color: red"
          >
            warning
          </mat-icon>
          <div i18n="@@survey.inside.cabling.proposal.header.floorplan">
            Floor plan
          </div>
        </div>
        <div class="section">
          <app-photo-and-remark
            [photos]="viewmodel.floorPlanPhotos"
            [surveyId]="survey.id"
            [limit]="10"
            [isAuthCanWrite]="isAuthCanWrite"
            [isInsidePhoto]="true"
            [camera]="camera"
            [cameraLayer]="cameraLayer"
            [surveyType]="surveyType.Inside"
            [surveyPhotoType]="surveyPhotoType.FloorPlan"
            [remarkFieldName]="generalPhotoRemarkFieldName"
            componentDescriptionTitle="Floor Plan"
          >
          </app-photo-and-remark>
        </div>
        <div
          style="display: flex; align-items: center; gap: 0.5rem"
          class="sub-title required"
        >
          <mat-icon
            *ngIf="
              getErrors(insideSurveyCablingProposal.BUILDING_LAYOUT_SUBTITLE)
            "
            style="color: red"
          >
            warning
          </mat-icon>
          <div i18n="@@survey.inside.cabling.proposal.title.buildinglayout">
            Building layout
          </div>
        </div>
        <div class="section layout-section">
          <div class="portrait-container">
            <div class="button-container">
              <div placeholder></div>
              <!-- Currently no delete functionality for building layout
                <button
                class="layout-button"
                *ngIf="isAuthCanWrite"
                [class.greyed]="!viewmodel.layoutPhotoURL"
                mat-stroked-button
                (click)="deleteBuildingLayout()"
              >
                <mat-icon class="material-icons-outlined"
                  >delete_outline</mat-icon
                >
                <span>delete</span>
              </button> -->
              <ng-container [ngSwitch]="viewmodel.layoutStatus">
                <button
                  *ngSwitchCase="uploadStates.done"
                  class="upload-gen upload-done"
                  mat-button
                  disabled
                >
                  <mat-icon class="upload-done">download_done</mat-icon>
                  <span class="upload-done">uploaded</span>
                </button>
                <button
                  *ngSwitchCase="uploadStates.ongoing"
                  class="upload-gen upload-ongoing"
                  mat-button
                  disabled
                >
                  <mat-icon
                    style="transform: rotate(-180deg)"
                    class="upload-ongoing"
                    >downloading</mat-icon
                  >
                  <span class="upload-ongoing">busy</span>
                </button>
                <button
                  *ngSwitchCase="uploadStates.failed"
                  class="upload-gen upload-failed"
                  mat-button
                  disabled
                >
                  <mat-icon class="upload-failed">sync_problem</mat-icon>
                  <span class="upload-failed">upload failed</span>
                </button>
                <div *ngSwitchDefault></div>
              </ng-container>
            </div>
            <div class="layout-container">
              <div
                *ngIf="viewmodel.layoutStatus == uploadStates.failed"
                class="reupload-bar"
                (click)="reuploadLayout()"
              >
                <span i18n="@@survey.photo.uploadfailed"
                  >Upload failed. Click here to retry</span
                >

                <mat-icon class="upload-failed">sync_problem</mat-icon>
              </div>
              <img
                class="building-layout"
                src="{{ viewmodel.layoutPhotoURL }}"
              />
            </div>
          </div>
          <div class="layout-buttons">
            <button
              mat-stroked-button
              class="layout-button"
              (click)="toggleBuildingLayoutEditor()"
              [class.disabled]="!this.isAuthCanWrite"
            >
              <mat-icon class="material-icons-outlined">draw</mat-icon>
              <span>draw</span>
            </button>
            <button
              mat-stroked-button
              class="layout-button"
              (click)="showCamera()"
              [class.disabled]="!this.isAuthCanWrite"
            >
              <mat-icon class="material-icons-outlined">camera_alt</mat-icon>
              <span>camera</span>
            </button>
            <button
              mat-stroked-button
              class="layout-button"
              (click)="galleryClick('existingLayoutPhoto', false)"
              [class.disabled]="!this.isAuthCanWrite"
            >
              <mat-icon class="material-icons-outlined">perm_media</mat-icon>
              <span>gallery</span>
            </button>
          </div>
          <input
            id="existingLayoutPhoto"
            #fileInput
            type="file"
            accept="image/*"
            style="display: none"
            (change)="this.addLayoutPhoto($event)"
          />
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            class="errorIcon"
            *ngIf="
              getErrorsForTitles([
                insideSurveyCablingProposal.PHOTO_GENERAL_SUBTITLE,
                insideSurveyCablingProposal.FACADE_PHOTO_SUBTITLE,
                insideSurveyCablingProposal.UNDERGROUND_PHOTO_SUBTITLE
              ])
            "
            >warning</mat-icon
          >
          <span i18n="@@survey.inside.cabling.proposal.title.cablingproposal"
            >Cabling proposal</span
          ></ng-template
        >
        <div
          style="display: flex; align-items: center; gap: 0.5rem"
          class="sub-title required"
        >
          <mat-icon
            *ngIf="getErrors(insideSurveyCablingProposal.FACADE_PHOTO_SUBTITLE)"
            style="color: red"
          >
            warning
          </mat-icon>
          <div i18n="@@survey.inside.cabling.proposal.header.photofacade">
            Photo facade
          </div>
        </div>
        <div class="section">
          <app-photo-and-remark
            [photos]="viewmodel.facadePhotos"
            [surveyId]="survey.id"
            [limit]="75"
            [isAuthCanWrite]="isAuthCanWrite"
            [isInsidePhoto]="true"
            [camera]="camera"
            [cameraLayer]="cameraLayer"
            [surveyType]="surveyType.Inside"
            [surveyPhotoType]="surveyPhotoType.Facade"
            [remarkFieldName]="generalPhotoRemarkFieldName"
            componentDescriptionTitle="Photo Facade"
          >
          </app-photo-and-remark>
        </div>
        <div
          style="display: flex; align-items: center; gap: 0.5rem"
          class="sub-title required"
        >
          <mat-icon
            *ngIf="
              getErrors(insideSurveyCablingProposal.UNDERGROUND_PHOTO_SUBTITLE)
            "
            style="color: red"
          >
            warning
          </mat-icon>
          <div i18n="@@survey.inside.cabling.proposal.header.photounderground">
            Photo underground
          </div>
        </div>
        <div class="section">
          <app-photo-and-remark
            [photos]="viewmodel.undergroundPhotos"
            [surveyId]="survey.id"
            [limit]="75"
            [isAuthCanWrite]="isAuthCanWrite"
            [isInsidePhoto]="true"
            [camera]="camera"
            [cameraLayer]="cameraLayer"
            [surveyType]="surveyType.Inside"
            [surveyPhotoType]="surveyPhotoType.Underground"
            [remarkFieldName]="generalPhotoRemarkFieldName"
            componentDescriptionTitle="Photo Underground"
          >
          </app-photo-and-remark>
        </div>
        <div
          style="display: flex; align-items: center; gap: 0.5rem"
          class="sub-title required"
        >
          <mat-icon
            *ngIf="
              getErrors(insideSurveyCablingProposal.PHOTO_GENERAL_SUBTITLE)
            "
            style="color: red"
          >
            warning
          </mat-icon>
          <div i18n="@@survey.inside.cabling.proposal.header.photogeneral">
            Photo general
          </div>
        </div>
        <div class="section">
          <app-photo-and-remark
            [photos]="viewmodel.generalPhotos"
            [surveyId]="survey.id"
            [limit]="75"
            [isAuthCanWrite]="isAuthCanWrite"
            [isInsidePhoto]="true"
            [camera]="camera"
            [cameraLayer]="cameraLayer"
            [surveyType]="surveyType.Inside"
            [surveyPhotoType]="surveyPhotoType.General"
            [remarkFieldName]="generalPhotoRemarkFieldName"
            componentDescriptionTitle="Photo General"
          >
          </app-photo-and-remark>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<div class="building-layout-overlay hidden" #buildingLayoutEditorLayer>
  <div class="header" (click)="buildingLayoutEditor.backButtonClicked()">
    <mat-icon>arrow_back_ios</mat-icon>
    <span i18n="@@survey.inside.layouteditor.title">Building layout</span>
  </div>
  <div class="scroll">
    <app-inside-survey-building-layout-editor
      #buildingLayoutEditor
      [survey]="survey"
      (imageSaved)="updateLayoutUrl($event)"
      (closeEditor)="toggleBuildingLayoutEditor()"
      (uploadStatus)="viewmodel.layoutStatus = $event"
    ></app-inside-survey-building-layout-editor>
  </div>
</div>
